import React from 'react';

const BusinessVerticals = () => {
  const verticals = [
    {
      title: "Home Cleaning Wipers",
      subtitle: "Floors, Tiles & Daily Cleaning"
    },
    {
      title: "Glass & Window Wipers",
      subtitle: "Home Windows & Shopfronts"
    },
    {
      title: "Bathroom & Kitchen Wipers",
      subtitle: "Water Cleaning & Hygiene Use"
    },
    {
      title: "Custom-Size Wipers",
      subtitle: "Tailored for Local Requirements"
    },
    {
      title: "Local & Regional Supply",
      subtitle: "Shops, States & Neighbouring Countries"
    }
  ];

  return (
    <section className="bg-white py-12 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <h2 className="text-2xl md:text-3xl font-extrabold text-black mb-10">
          Our Product Categories
        </h2>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 md:gap-0">
          {verticals.map((item, index) => (
            <div 
              key={index} 
              className={`flex-1 w-full md:w-auto ${
                index !== verticals.length - 1 ? 'md:border-r border-blue-700 md:pr-8' : ''
              } ${index !== 0 ? 'md:pl-8' : ''}`}
            >
              <h3 className="text-xl font-bold text-black mb-1 leading-tight">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm font-medium">
                {item.subtitle}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BusinessVerticals;